import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { PreLoginWelcomeUserBaseView } from "./PreLoginWelcomePageBaseView";
import { HealthExIllustrationImage, ResearcherWelcomeBackImage, WelcomeUserButton, CenterAlignedButtonArea, } from "./WelcomeUser.shared.styles";
import { WelcomeBackOrgUserViewModel } from "./WelcomeBackOrgUserViewModel";
import { useViewModel } from "./useViewModel";
export const WelcomeBackOrgUserView = observer((props) => {
    const model = useViewModel(WelcomeBackOrgUserViewModel, props.container);
    const title = "Welcome back!";
    const description = (_jsx(_Fragment, { children: "It looks like you started to create an account but didn\u2019t have a chance to finish setting it up. Would you like to pick up where you left off?" }));
    return (_jsxs(PreLoginWelcomeUserBaseView, { title: title, description: description, children: [model.isHealthcareOrg ? _jsx(HealthExIllustrationImage, {}) : _jsx(ResearcherWelcomeBackImage, {}), _jsxs(CenterAlignedButtonArea, { children: [_jsx(WelcomeUserButton, { type: "submit", onClick: (e) => {
                            e.preventDefault();
                            model.go();
                        }, children: _jsx(Trans, { children: "Continue where I left off" }) }), _jsx(WelcomeUserButton, { text: true, onClick: (e) => {
                            e.preventDefault();
                            model.startFromBeginning();
                        }, children: _jsx(Trans, { children: "Start from beginning" }) })] })] }));
});
